<mat-form-field [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize  : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group" appearance="fill" [matTooltip]="field.hint"
  [matTooltipDisabled]="!field.hint" matTooltipPosition="above" matTooltipClass="sbm-tooltip">

  <mat-label>
    <app-required *ngIf="isRequired()"></app-required>
    <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
    {{field.label}}
  </mat-label>

  <mat-select [placeholder]="field.label" [formControlName]="field.name">
    <mat-option *ngFor="let item of field.fieldOptions" [value]="item">{{item}}</mat-option>
  </mat-select>

  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).hasError(validation.name)">
      {{validation.message ? validation.message : getValidationMessage(validation.name)}}
    </mat-error>
  </ng-container>
</mat-form-field>
